import { useContext } from 'react';

import { FeatureFlagsContext } from '../services/featureFlags/FeatureFlagsContext';
import { FeatureFlagName } from '@/utils/featureFlags';

interface FeatureFlagsContextType {
  isSuitableSubstitutesEnabled: boolean;
  isPartFinderEnabled: boolean;
  isNewCompareAssetsUiEnabled: boolean;
  isSupplementalAssetsEnabled: boolean;
  isCriticalGeometryEnabled: boolean;
  isMetadataSearchEnabled: boolean;
  isUsageAnalyticsEnabled: boolean;
  isImageSearchCroppingDisabled: boolean;
}

export const useFeatureFlags = (): FeatureFlagsContextType => {
  const context = useContext(FeatureFlagsContext);
  if (!context) {
    throw new Error('useFeatureFlagsContext must be used within a FeatureFlagsProvider');
  }
  return {
    isSuitableSubstitutesEnabled: context.isFeatureEnabled(FeatureFlagName.SUITABLE_SUBSTITUTES),
    isPartFinderEnabled: context.isFeatureEnabled(FeatureFlagName.PART_FINDER_REPORTS),
    isNewCompareAssetsUiEnabled: context.isFeatureEnabled(FeatureFlagName.NEW_COMPARE_ASSETS_UI),
    isSupplementalAssetsEnabled: context.isFeatureEnabled(FeatureFlagName.SUPPLEMENTAL_ASSETS),
    isCriticalGeometryEnabled: context.isFeatureEnabled(FeatureFlagName.CRITICAL_GEOMETRY),
    isMetadataSearchEnabled: context.isFeatureEnabled(FeatureFlagName.METADATA_SEARCH_UI),
    isUsageAnalyticsEnabled: context.isFeatureEnabled(FeatureFlagName.USAGE_ANALYTICS),
    isImageSearchCroppingDisabled: context.isFeatureEnabled(FeatureFlagName.IMAGE_SEARCH_CROPPING_DISABLED),
  };
};
